export class getOigListeBase {

  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string = "importedBy";
  orderType: string = "asc";
  type: string = "string";
  field: string = "importedBy";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
}

export class matchedEMPBO {
  lEIEBOs: LEIEBO;
  employeeBOs: EmployeeBO
}

export class EmployeeBO {
  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  name: string;
  gender_Name: string;
  username: string;
  sSNlast4digits: string;
  employeeTypeLidName: string;
  locationName: string;
  statusLidName: string;
  age: number;
  dOB: string;
  apt: string;
  street: string;
  city: string;
  steet: string;
  zipcode: string;
  county: string;
  phone1: string;
  phone2: string;
  email: string;
  uMPI: string;
  sSN: string;
  pCACertificateNumber: string;
  actieEmp: number;
  aKA: string;
  rNNPI: string;
  requiredEVV: boolean | null;
  isEligibleForManualETimeSheet: boolean;
  hiredate: string | null;
  inactivedate: string | null;
  terminationdate: string | null;
  pEmployeeId: number | null;
  officeStaff: boolean;
  employeeTypeLid: string | null;
  genderLid: string;
  languageLid: string[];
  language: string[];
  driverLicense: string;
  placeofBirth: string;
  locationId: string;
  maritalStatusLid: string | null;
  statusLid: string;
  agencyId: string;
  loginUserId: string | null;
  agencyName: string;
  activeUMPI: number;
}

export class LEIEBO {
  iD: string;
  fIRSTNAME: string;
  lASTNAME: string;
  mIDNAME: string;
  bUSNAME: string;
  gENERAL: string;
  sPECIALTY: string;
  dOB?: string;
  uPIN: string;
  nPI: string;
  aDDRESS: string;
  sTATE: string;
  cITY: string;
  zIPCODE: string;
  eXCLTYPE: string;
  eXCLDATE?: string;
  rEINDATE?: string;
  wAIVERDATE?: string;
  wAIVERSTATE: string;
}



